import { autofocusAttr } from 'hooks/useAutofocusAttr';

interface SaleTypePopupProps {
  /** data-name of the CURRENTLY persisted type (option[data-name]). */
  checked: string;
  /** data-name of the type being switched to. */
  changeChecked: string;
  onConfirm: () => void;
  onClose: () => void;
}

/**
 * SaleTypePopup (`sales/view/sale_type_popup.js` + sale_type_popup.tmpl,
 * §3.9 / parity 73): opened when changing Sale Type FROM "Direct" (id 1).
 * Exact copy — "Change Sale Type?" heading, the from/to sentence, Change
 * (highlighted, autofocus ⇒ ENTER confirms) / Cancel. ESC rides the global
 * popup keys via `button[name=cancel_change]` (the legacy MainView Esc
 * removes the active popup without applying — same observable outcome).
 *
 * [NEG] honored (parity 86): the confirm's legacy radio re-check
 * (`input[name=sale_type_id][value=X]`) targets radios that don't exist —
 * the UI is a select; not rebuilt.
 */
const SaleTypePopup = ({ checked, changeChecked, onConfirm, onClose }: SaleTypePopupProps) => (
  <div className="popup-wrapper width-small active">
    <div className="popup-content change-sale-type-popup">
      <div className="popup-heading">
        <h2>Change Sale Type?</h2>
      </div>
      <div className="popup-content-part">
        <p>
          If you choose to Change Sale Type from {checked} to {changeChecked}, all
          Commission information will be lost and will not be recoverable.
        </p>
      </div>
      <div className="popup-control-buttons">
        <button
          className="btn right highlighted-btn"
          name="confirm_change"
          ref={autofocusAttr}
          onClick={onConfirm}
        >
          Change
        </button>
        <button className="btn right not-highlighted-btn" name="cancel_change" onClick={onClose}>
          Cancel
        </button>
      </div>
    </div>
  </div>
);

export default SaleTypePopup;
